import React__default from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { LegacyColorMap } from '../../../theme/LegacyColorMap.es.js';
import { Avatar } from '../../display/Avatar/Avatar.es.js';
import 'clsx';
import { remapDeprecatedColors } from '../TestimonialSolo/TestimonialMapping.es.js';
import { TestimonialSolo } from '../TestimonialSolo/TestimonialSolo.es.js';

const quote = "_quote_1fgfm_1";
const author = "_author_1fgfm_30";
const company = "_company_1fgfm_48";
const twoColumnOuterBox = "_two-column-outer-box_1fgfm_66";
const twoColumnGrid = "_two-column-grid_1fgfm_81";
const twoColumnContent = "_two-column-content_1fgfm_101";
const twoColumnAvatarContainer = "_two-column-avatar-container_1fgfm_117";
const twoColumnBorder = "_two-column-border_1fgfm_127";
const threeColumnOuterBox = "_three-column-outer-box_1fgfm_133";
const threeColumnGrid = "_three-column-grid_1fgfm_148";
const threeColumnContent = "_three-column-content_1fgfm_168";
const threeColumnInnerFlex = "_three-column-inner-flex_1fgfm_184";
const styles = {
	quote: quote,
	author: author,
	company: company,
	twoColumnOuterBox: twoColumnOuterBox,
	twoColumnGrid: twoColumnGrid,
	twoColumnContent: twoColumnContent,
	twoColumnAvatarContainer: twoColumnAvatarContainer,
	twoColumnBorder: twoColumnBorder,
	threeColumnOuterBox: threeColumnOuterBox,
	threeColumnGrid: threeColumnGrid,
	threeColumnContent: threeColumnContent,
	threeColumnInnerFlex: threeColumnInnerFlex
};

const renderContentForTwoColumn = (props, index) => {
  return React__default.createElement(
    "div",
    { className: styles.twoColumnContent, "data-zds": true },
    props.testimonials[index].hasAuthorAvatar && React__default.createElement(
      "div",
      { className: styles.twoColumnAvatarContainer, "data-zds": true },
      React__default.createElement(Avatar, { "data-testId": "Avatar", name: props.testimonials[index].author, url: props.testimonials[index].avatarUrl, size: "medium" })
    ),
    React__default.createElement("div", { className: styles.quote, "data-zds": true }, props.testimonials[index].quote),
    React__default.createElement("p", { className: styles.author, "data-zds": true }, props.testimonials[index].author),
    React__default.createElement("p", { className: styles.company, "data-zds": true }, props.testimonials[index].company)
  );
};
const renderTwoColumn = (props) => {
  return React__default.createElement(
    "div",
    { className: styles.twoColumnOuterBox, style: {
      "--_zds-testimonialcolumn-background-color": Colors[LegacyColorMap[remapDeprecatedColors(props.backgroundColor || "neutral100")]]
    }, "data-zds": true },
    React__default.createElement(
      "div",
      { className: styles.twoColumnGrid, "data-zds": true },
      renderContentForTwoColumn(props, 0),
      React__default.createElement("div", { className: styles.twoColumnBorder, "data-zds": true }),
      renderContentForTwoColumn(props, 1)
    )
  );
};
const renderThreeColumn = (props) => {
  return React__default.createElement(
    "div",
    { className: styles.threeColumnOuterBox, style: {
      "--_zds-testimonialcolumn-background-color": Colors[LegacyColorMap[remapDeprecatedColors(props.backgroundColor || "neutral100")]]
    }, "data-zds": true },
    React__default.createElement("div", { className: styles.threeColumnGrid, "data-zds": true }, props.testimonials.slice(0, props.numberOfColumns).map((testimonial, index) => React__default.createElement(
      "div",
      { key: index, className: styles.threeColumnContent, "data-zds": true },
      React__default.createElement("div", { className: styles.quote, "data-zds": true }, testimonial.quote),
      testimonial.hasAuthorAvatar ? React__default.createElement(
        "div",
        { className: styles.threeColumnInnerFlex, "data-zds": true },
        React__default.createElement(
          "div",
          { className: styles.twoColumnAvatarContainer, "data-zds": true },
          React__default.createElement(Avatar, { "data-testId": "Avatar", name: testimonial.author, url: testimonial.avatarUrl, size: "medium" })
        ),
        React__default.createElement(
          "div",
          { "data-zds": true },
          React__default.createElement("p", { className: styles.author, "data-zds": true }, testimonial.author),
          React__default.createElement("p", { className: styles.company, "data-zds": true }, testimonial.company)
        )
      ) : React__default.createElement(
        "div",
        { "data-zds": true },
        React__default.createElement("p", { className: styles.author, "data-zds": true }, testimonial.author),
        React__default.createElement("p", { className: styles.company, "data-zds": true }, testimonial.company)
      )
    )))
  );
};
const TestimonialMultipleColumn = (props) => {
  if (props.testimonials.length === 1) {
    const testimonial = props.testimonials[0];
    return React__default.createElement(TestimonialSolo, { backgroundColor: props.backgroundColor, avatarUrl: testimonial.avatarUrl, company: testimonial.company, quote: testimonial.quote, author: testimonial.author });
  }
  const renderType = props.numberOfColumns === 2 ? renderTwoColumn : renderThreeColumn;
  return renderType(props);
};

export { TestimonialMultipleColumn };
//# sourceMappingURL=TestimonialMultipleColumn.es.js.map
